import { featureFlagClient, useFeatureFlag } from '@trello/feature-flag-client';

const FLAG = 'teamplates.web.logged-out-nav';

export enum LoggedOutNavExperimentVariations {
  CONTROL = 'control',
  NOT_ENROLLED = 'not-enrolled',
  EXPERIMENT = 'experiment',
}

interface FlagOptions {
  attributes?: object;
  sendExposureEvent?: boolean;
}

export const useLoggedOutHeaderExperiment = (options?: FlagOptions) => {
  return useFeatureFlag<LoggedOutNavExperimentVariations>(
    FLAG,
    LoggedOutNavExperimentVariations.NOT_ENROLLED,
    options,
  );
};

export const getLoggedOutHeaderExperiment = () => {
  return featureFlagClient.get<LoggedOutNavExperimentVariations>(
    FLAG,
    LoggedOutNavExperimentVariations.NOT_ENROLLED,
  );
};
